export const servicesLayout = [
    {
        id: 0,
        sectionClasses: 'section-row-reverse',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 1,
        sectionClasses: 'section-row',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-cream',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 2,
        sectionClasses: 'section-row-reverse',
        linkColor: 'link-white',
        style: {
            background: 'section-bg-red',
            color: 'section-color-white',
            flexDirection: 'row'
        }
    },
    {
        id: 3,
        sectionClasses: 'section-row',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 4,
        sectionClasses: 'section-row-reverse',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 5,
        sectionClasses: 'section-row',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-cream',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 6,
        sectionClasses: 'section-row-reverse',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 7,
        sectionClasses: 'section-row',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 8,
        sectionClasses: 'section-row-reverse',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 9,
        sectionClasses: 'section-row',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 10,
        sectionClasses: 'section-row-reverse',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 11,
        sectionClasses: 'section-row',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 12,
        sectionClasses: 'section-row-reverse',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 13,
        sectionClasses: 'section-row',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 14,
        sectionClasses: 'section-row-reverse',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 15,
        sectionClasses: 'section-row',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 16,
        sectionClasses: 'section-row-reverse',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 17,
        sectionClasses: 'section-row',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 18,
        sectionClasses: 'section-row-reverse',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    },
    {
        id: 19,
        sectionClasses: 'section-row',
        linkColor: 'link-navy',
        style: {
            background: 'section-bg-white',
            color: 'section-color-navy',
            flexDirection: 'row'
        }
    }
];